import { IDataSet } from '../Track';
import { FBTrackingEvent } from '../FBTrackingEvent';

export class FTUXDataSet implements IDataSet {
    stepId: number = 0;
    stepName: FBTrackingEvent = undefined;
    ftuxVersion: number = 1;
}
